import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { SharedService } from '../../../services/shared.service';
import { CryptoService } from "../../../services/crypto.service";
import * as moment from "moment-timezone";

@Component({
  selector: 'support-pay',
  templateUrl: './pay.component.html',
  styleUrls: ['./pay.component.scss']
})
export class SupportPayComponent implements OnInit {
  cardForm: any = {
    number: '',
    name: '',
    expire_month: '',
    expire_year: ''
  }

  @Output() start = new EventEmitter();
  @Input() currentSupportPlan: any;

  constructor(
      public auth: AuthService,
      private shared: SharedService,
      private crypto: CryptoService
    ) {}

  ngOnInit() {
    if (this.auth.user.card !== undefined) {
      this.cardForm = Object.assign({}, this.auth.user.card)
      this.cardForm.name = this.crypto.decrypt(this.cardForm.name)
      this.cardForm.expire_month = parseInt(this.crypto.decrypt(this.cardForm.expire_month))
      this.cardForm.expire_year = parseInt(this.crypto.decrypt(this.cardForm.expire_year))
      this.cardForm.number = this.crypto.decrypt(this.cardForm.number)
    }
  }

  pay() {
    this.start.emit();
  }

  alreadySupporting() {
    return this.currentSupportPlan && this.currentSupportPlan.stoppedAt === undefined
  }
}
